import type { FaireProductEntity } from "../../entity_types/product";

export const p_utm93nj9ns: FaireProductEntity = {
  token: "p_utm93nj9ns",
  type: "product",
  name: "Sonia Sweater Tee - Stratus (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/495ba6c4c7bb44328e14138e28c0332f8a230c6fcd470207f48de2902d0eac36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87d42ff9af6a9494a52513658d8fac901aed40bb2499622337b41784913f14f5.jpeg",
    "https://cdn.faire.com/fastly/4dbec049b93ed9fb2add0f51c7c83b2c3630f56a191670f59f4db506d3e835b5.jpeg",
    "https://cdn.faire.com/fastly/4c1dc68572c83b55497fd3d8bbd6b1617d1fa1f2fc71f53020b74c0799d7cd53.jpeg",
    "https://cdn.faire.com/fastly/eae493d7c13da598c7eccd9c3403c74e3a49d9fea85f8ce112374ab0b67aa674.jpeg",
    "https://cdn.faire.com/fastly/7213b35249078ca307eaf24fa3eb4ab3cc984946aed6de5c55ef169c00f5cd47.jpeg",
    "https://cdn.faire.com/fastly/ae6545139882a8d81f417a82ca0e58b54f5f1d1e436b9149564b2bff88831d5c.jpeg",
    "https://cdn.faire.com/fastly/75584b8292c0b170942994647a06fda28ccef29aee996ff3ae87c6636673bcbc.jpeg",
    "https://cdn.faire.com/fastly/95684b1303845cb067b02269ed9e28fa70a6925c98a68a577255703c37334bc3.jpeg",
    "https://cdn.faire.com/fastly/50d3d37c8bca324c5361bb48372327b1bf843274c002a9163faad750f85a2dd4.jpeg",
    "https://cdn.faire.com/fastly/6f42407e396589f17d5a70ef8f51bd9bcad23ff1ca363944b507d4140bd450e3.jpeg",
    "https://cdn.faire.com/fastly/4f14d13ecbeb19df88345c84f5fe7585400743fb16b36e8dfd47ad5074406109.jpeg",
    "https://cdn.faire.com/fastly/724f0ddf6cc35e3d4fe1f4780cdcd2532132b9b4802910ae4bc768a7783dd2ea.jpeg"
  ],
  priceDollars: 80.1,
  description: "The Sonia Sweater Tee brings bold geometry and effortless versatility together in one piece. Knit from 100% cotton, its richly colored checkerboard pattern is inspired by the playful balance of color and form found in modernist art. The relaxed fit and soft, breathable knit make it an easy choice for everyday wear, whether layered through the seasons or worn on its own.\n\n * 100% Cotton \n * Soft, breathable knit \n * Relaxed fit \n * Made in Peru \n * Ethically crafted in small batches ",
  tags: [],
  msrpDollars: 178,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:26.599Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
